import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  action,
  children,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <header className="flex flex-col gap-4 px-4 pb-4 pt-6 sm:px-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0">
          <h1 className="font-display text-title text-strong">{title}</h1>
          {subtitle && <p className="mt-1 text-body text-muted">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </header>
  );
}

/** Content is capped at 1440px and centred; every page opts into the same box. */
export function PageBody({ children }: { children: ReactNode }) {
  return <div className="mx-auto w-full max-w-content px-6 pb-12">{children}</div>;
}
